module.exports = __webpack_public_path__ + "img/features-map-editor.df55d77a.png";